/* SAFA V21 · héro, rails, fiche produit, menu, signature */
(function () {
  'use strict';
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n) { return ('0' + n).slice(-2); }

  function hero(root) {
    var slides = $$('.v21-hero__slide', root), btns = $$('[data-v21-go]', root), grid = root.querySelector('.v21-hero__grid'), cur = root.querySelector('[data-v21-hcur]');
    if (slides.length < 2) return;
    var i = 0, timer = null, D = 5000;
    root.style.setProperty('--hero-d', D + 'ms');
    function go(n) {
      var prev = i;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.remove('is-on', 'is-left');
        if (k === i) s.classList.add('is-on');
        else if (k === prev) s.classList.add('is-left');
      });
      btns.forEach(function (b, k) { b.classList.remove('is-on'); if (k === i) { void b.offsetWidth; b.classList.add('is-on'); } b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var bg = slides[i].getAttribute('data-bg'); if (bg && grid) grid.style.background = bg;
      if (cur) cur.textContent = pad(i + 1);
    }
    function play() { stop(); if (!reduce) timer = setInterval(function () { go(i + 1); }, D); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    btns.forEach(function (b, k) { b.addEventListener('click', function () { go(k); play(); }); });
    var pv = root.querySelector('[data-v21-hprev]'), nx = root.querySelector('[data-v21-hnext]');
    if (pv) pv.addEventListener('click', function () { go(i - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
    var media = root.querySelector('.v21-hero__media');
    if (media) {
      media.addEventListener('mouseenter', function () { stop(); root.classList.add('is-paused'); });
      media.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); play(); });
      var x0 = null;
      media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); } x0 = null; });
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
    go(0); play();
  }

  function rails() {
    $$('[data-v21-rail]').forEach(function (rail) {
      if (rail.__v21) return; rail.__v21 = 1;
      var sec = rail.closest('section'); if (!sec) return;
      var p = sec.querySelector('[data-v21-prev]'), n = sec.querySelector('[data-v21-next]');
      function step(dir) { var c = rail.firstElementChild; var w = c ? c.getBoundingClientRect().width + 18 : 300; rail.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' }); }
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });
  }

  function gallery(g) {
    var track = g.querySelector('[data-v21-gal-track]'); if (!track) return;
    var slides = $$('.v21-gal__slide', track), dots = $$('.v21-gal__dots li', g), thumbs = $$('[data-v21-gal-go]', g.parentNode);
    var i = -1;
    function mark(n) {
      if (n === i) return; i = n;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
      thumbs.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
      slides.forEach(function (s, k) { var v = s.querySelector('video'); if (!v) return; if (k === n) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }
    function go(n) { n = Math.max(0, Math.min(slides.length - 1, n)); track.scrollTo({ left: n * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); mark(n); }
    track.addEventListener('scroll', function () { var w = track.clientWidth || 1; mark(Math.round(track.scrollLeft / w)); }, { passive: true });
    var pv = g.querySelector('[data-v21-gal-prev]'), nx = g.querySelector('[data-v21-gal-next]');
    if (pv) pv.addEventListener('click', function () { go(i - 1); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    mark(0);
  }

  function pdp(root) {
    var form = root.querySelector('[data-v21-form]'); if (!form) return;
    var qty = form.querySelector('[data-v21-qty]'), opts = $$('.v21-pick__opt', form), price = form.querySelector('[data-v21-atc-price]');
    var bar = root.querySelector('[data-v21-bar]'), bName = root.querySelector('[data-v21-bar-name]'), bPrice = root.querySelector('[data-v21-bar-price]');
    function sync() {
      var on = form.querySelector('input[name="v21-offer"]:checked');
      opts.forEach(function (o) { o.classList.toggle('is-on', !!on && o.contains(on)); });
      var lab = on ? on.closest('.v21-pick__opt') : null; if (!lab) return;
      var q = lab.getAttribute('data-qty');
      qty.value = q;
      if (price) price.textContent = lab.getAttribute('data-total');
      if (bName) bName.textContent = q + ' pot' + (q > 1 ? 's' : '') + ' · ' + lab.getAttribute('data-name');
      if (bPrice) bPrice.textContent = lab.getAttribute('data-total');
    }
    form.addEventListener('change', sync); sync();
    var atc = root.querySelector('[data-v21-atc]');
    if (bar && atc && 'IntersectionObserver' in window) {
      var foot = document.querySelector('.v21-footer');
      var st = { atc: true, foot: false };
      var render = function () { var on = !st.atc && !st.foot; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); var b = bar.querySelector('button'); if (b) b.tabIndex = on ? 0 : -1; };
      new IntersectionObserver(function (e) { st.atc = e[0].intersectionRatio > 0.85; render(); }, { threshold: [0, 0.85, 1] }).observe(atc);
      if (foot) new IntersectionObserver(function (e) { st.foot = e[0].isIntersecting; render(); }).observe(foot);
    }
  }

  function header() {
    var h = document.querySelector('[data-v21-header]'); if (!h || h.__v21) return; h.__v21 = 1;
    var html = document.documentElement, burger = h.querySelector('[data-t-burger]');
    function hh() { var b = h.getBoundingClientRect().bottom; html.style.setProperty('--v21-hh', Math.max(0, Math.round(b)) + 'px'); }
    function set(open) { h.classList.toggle('is-open', open); html.classList.toggle('t-nav-open', open); if (burger) { burger.setAttribute('aria-expanded', open ? 'true' : 'false'); burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu'); } }
    if (burger) burger.addEventListener('click', function () {
      hh(); var before = h.classList.contains('is-open');
      setTimeout(function () { var now = h.classList.contains('is-open'); if (now === before) set(!before); else set(now); hh(); }, 30);
    }, true);
    h.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('.v21-nav a'); if (a) setTimeout(function () { set(false); }, 10); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && h.classList.contains('is-open')) set(false); });
    var tick = false;
    function onScroll() { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; var d = document.documentElement, max = d.scrollHeight - innerHeight; h.style.setProperty('--v21-p', max > 0 ? Math.min(1, scrollY / max).toFixed(4) : 0); if (!h.classList.contains('is-open')) hh(); }); }
    addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', hh); onScroll(); hh();
  }

  function railUI() {
    var mq = window.matchMedia ? matchMedia('(max-width: 989px)') : { matches: false };
    $$('[data-v21-rail]').forEach(function (rail) {
      if (rail.__ui) return; rail.__ui = 1;
      var cards = rail.children.length; if (cards < 2) return;
      var hint = document.createElement('p'); hint.className = 'v21-rail-hint'; hint.setAttribute('aria-hidden', 'true'); hint.innerHTML = 'Glisse pour voir la suite <b>→</b>';
      var ui = document.createElement('div'); ui.className = 'v21-rail-ui'; ui.setAttribute('aria-hidden', 'true'); ui.innerHTML = '<span class="v21-rail-ui__bar"><i></i></span><span class="v21-rail-ui__n"><b>1</b> / ' + cards + '</span>';
      rail.parentNode.insertBefore(hint, rail); rail.parentNode.insertBefore(ui, rail.nextSibling);
      var bar = ui.querySelector('i'), n = ui.querySelector('b');
      function upd() { var max = rail.scrollWidth - rail.clientWidth; var p = max > 0 ? rail.scrollLeft / max : 1; bar.style.setProperty('--rp', (0.15 + 0.85 * p).toFixed(3)); var c = rail.firstElementChild, w = c ? c.getBoundingClientRect().width + 18 : 300; n.textContent = Math.min(cards, Math.round(rail.scrollLeft / w) + 1); if (rail.scrollLeft > 30) hint.classList.add('is-gone'); }
      rail.addEventListener('scroll', upd, { passive: true }); upd();
      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (e) { if (!e[0].isIntersecting || !mq.matches) return; io.disconnect(); if (rail.scrollLeft > 10) return; setTimeout(function () { rail.classList.add('is-nudge'); setTimeout(function () { rail.classList.remove('is-nudge'); }, 2400); }, 500); }, { threshold: 0.6 });
        io.observe(rail);
      }
    });
  }

  function init() { header(); railUI(); $$('[data-v21-hero]').forEach(hero); rails(); $$('[data-v21-gal]').forEach(gallery); $$('[data-v21-pdp]').forEach(pdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { var h = e.target.querySelector('[data-v21-hero]'); if (h) hero(h); rails(); var g = e.target.querySelector('[data-v21-gal]'); if (g) gallery(g); var p = e.target.querySelector('[data-v21-pdp]'); if (p) pdp(p); railUI(); });
})();